import * as React from 'react'

export const BlogMobileMenu = (props: any) => {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" {...props}>
      <g data-name="20x20/three-dots--grey" transform="rotate(90 12 12)">
        <path fill="none" d="M0 0H24V24H0z" />
        <circle
          cx={1}
          cy={1}
          r={1}
          transform="translate(5 11)"
          stroke="#000"
          strokeMiterlimit={10}
          strokeWidth={0.5}
        />
        <circle
          data-name="Oval"
          cx={1}
          cy={1}
          r={1}
          transform="translate(11 11)"
          stroke="#000"
          strokeMiterlimit={10}
          strokeWidth={0.5}
        />
        <circle
          data-name="Oval"
          cx={1}
          cy={1}
          r={1}
          transform="translate(17 11)"
          stroke="#000"
          strokeMiterlimit={10}
          strokeWidth={0.5}
        />
      </g>
    </svg>
  )
}
